require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-november-2020.json") })
        }
      }, "path---en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-november-2020");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-november-2020!./.cache/json/en-relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-november-2020.json
// module id = 613
// module chunks = 231608221292675